import {ValueObject} from '@s-ui/domain'

export class SuggestionsAssistantValueObject extends ValueObject {
  #suggestions

  constructor({suggestions}) {
    super()
    this.#suggestions = suggestions
  }

  static create({suggestions = []}) {
    return new SuggestionsAssistantValueObject({suggestions})
  }

  get suggestions() {
    return this.#suggestions
  }

  get value() {
    return {
      suggestions: this.#suggestions
    }
  }

  toJSON() {
    return {
      suggestions: this.#suggestions
    }
  }
}
